var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"footer-props":_vm.tableFooterProps,"headers":_vm.tableHeaders,"items":_vm.dadosRelatorio,"loading":_vm.loading,"options":{ itemsPerPage: 10 },"search":_vm.search,"no-data-text":"Nenhum resultado encontrado"}})
}
var staticRenderFns = []

export { render, staticRenderFns }